//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  data() {
    return {
      diferenciais: [
        {
          icon: 'plus',
          title: 'Máxima aplicabilidade',
          desc: 'A cada trilha o aluno aplica seu projeto à sua realidade profissional.',
        },
        {
          icon: 'comments',
          title: 'Momentos ao vivo de interação',
          desc: 'Momentos de orientação ao vivo com docentes especializados.',
        },
        {
          icon: 'id-card',
          title: 'Master Class com especialistas',
          desc: 'Master Class ao vivo com pessoas que são autoridades em inovação em educação',
        },
        {
          icon: 'chalkboard-teacher',
          title: 'Preceptoria',
          desc: 'Acompanhamento e feedback  personalizado com docentes experientes.',
        },
        {
          icon: 'user',
          title: 'Assessoramento individual',
          desc: 'Assessoria de tutor para organização e suporte técnico nos processos do curso.',
        },
        {
          icon: 'cubes',
          title: 'Nano degree (Certificados Parciais)',
          desc: 'Certificados de competências ao longo do curso, enriquecendo seu currículo antes mesmo de concluir  todo o MBA.',
        },
        {
          icon: 'cogs',
          title: 'Aprendizagem personalizada',
          desc: 'Todos os projetos aplicados durante o curso consideram as necessidades do contexto profissional do aluno.',
        },
      ],
    }
  },
}
// export default {
//   async asyncData({ $http }) {
//     const blogs = JSON.parse(await $http.$get('/blog/index.json'))

//     return { blogs }
//   },
// }
